const de = {
  /**
   * Genereal
   */
  general: {
    back: 'zurück',
    error:
      'Ein unvorhergesehener Fehler ist aufgetreten. Wir wurden darüber informiert und schauen uns das an.',
    next: 'weiter',
    logout: 'Logout',
    country: 'Land',
    countries: {
      aut: 'Österreich',
      bel: 'Belgien',
      ch: 'Schweiz',
      de: 'Deutschland',
      dk: 'Dänemark',
      fr: 'Frankreich',
      es: 'Spanien',
      irl: 'Irland',
      it: 'Italien',
      lux: 'Luxemburg',
      nl: 'Niederlande',
      nor: 'Norwegen',
      pol: 'Polen',
      pt: 'Portugal',
      swe: 'Schweden',
      uk: 'Vereinigtes Königreich',
    },
  },
  /**
   * Hero
   */
  hero: {
    title: 'Finde neue Clubs und Bars auf der ganzen Welt!',
    subtitle:
      ' verbindet Leute mit ähnlichen Musik-Interessen weltweit und hilft dir so bei der Suche nach Clubs und Bars, die genau zu dir passen',
    navigation: {
      cta: 'Jetzt testen',
      about: 'About',
      features: 'Features',
      feedback: 'Feedback',
    },
  },
  /**
   *  usersQuotes
   */
  usersQuote: {
    julia:
      'Hey cool, da gehe ich in Hamburg [Große Freiheit, kleinraumdisco] tatsächlich gerne hin.',
    clara:
      'Meine Freunde waren begeistert und den meisten ist gleich eine Situation eingefallen, in der sie die App gut hätten gebrauchen können.',
    leah: 'Ohja, da war ich vor einiger Zeit, das war echt cool!',
    cosmo:
      'Endlich eine perfekte Möglichkeit, nach langen Suchen quer durch das Internet und Apps um den richtigen Club zu finden',
  },
  /**
   * About
   */
  about: {
    title: 'Das ist {logo}',
    text:
      'Die App verbindet dich mit Leuten mit ähnlichen Musik-Interessen weltweit und hilft dir so bei der Suche nach geeigneten Clubs und Bars. Und nicht nur das, auch in deiner eigenen Stadt kannst du Leute finden, die mit dir auf einer Wellenlänge sind. Denn nichts verbindet uns mit anderen Menschen mehr als unser Musikgeschmack!',
    button: 'Die ganze Geschichte',
  },
  /**
   * Features
   */
  features: {
    title: 'So funktioniert {logo}',
    yourTop: 'Abgesehen von {clubs} könnten dir in {city} noch gefallen:',
    text:
      'Du willst wissen, welches deine Top 3 Clubs in deiner Stadt sind? Dann logge dich jetzt ein mit Spotify! Wenn du einfach nur sehen willst wie die App funktioniert, dann mache weiter ohne Login.',
    withLogin: 'Jetzt einloggen',
    withoutLogin: 'Weiter ohne login',
    withLoginWizard: {
      step1:
        'Zunächst brauche ich einmal ein paar deiner Lieblingsclubs und Bars in deiner Heimatstadt. Die Angaben werden gespeichert und helfen anderen Nutzer*innen bei ihren Vorschlägen.',
      step2:
        'Zunächst brauche ich einmal ein paar deiner Lieblingsclubs und Bars in deiner Heimatstadt. Die Angaben werden gespeichert und helfen anderen Nutzer*innen bei ihren Vorschlägen.',
      step3:
        'Nach dem Login kannst du in bereits 20 europäischen Großstädten suchen und erhältst Vorschläge aus über 2600 Clubs und Bars. Ein Algorithmus gleicht dabei deine meistgehörten Bands und Genres mit den Followern der Clubs und Bars ab, bzw. Bands die hier zuletzt gespielt haben.',
      step4:
        'Auf einer Karte kannst du sehen, wo sich der/die Club/Bar befindet und erhältst weitere Infos. Welche Musik dich hier vermutlich erwartet basiert auf den Followern dieser Clubs/Bars bzw. welche Bands hier zuletzt gespielt haben.',
      step5:
        'Wenn du keine Lust hast alleine auszugehen, dann schalte dich für 48 Stunden sichtbar für alle anderen, die dies ebenfalls in der Stadt gerade gemacht haben.',
      step6:
        'Nach einem gegenseitigen Match könnt ihr euch dann über die App schreiben. Wie genau die Matchingfunktion funktioniert kannst du mit beeinflussen. Wie? Melde dich weiter unten als Tester*in und ich erzähle dir mehr.',
      noResults:
        'Hier gibt es noch nichts zu entdecken. Ich kümmere mich drum :)',
      fewResults:
        'Hier gibt es noch nicht mehr zu entdecken. Ich kümmere mich drum :)',
      city: 'Deine Stadt',
      club: 'Lieblingsclub in {city}',
      bar: 'Lieblingsbar in {city}',
    },
  },
  /**
   * Feedback
   */
  feedback: {
    title: 'Das sagen Nutzer*innen über {logo}',
  },
  /**
   * Contact
   */
  contact: {
    title: 'Neugierig geworden?',
    text:
      'Dann melde dich jetzt bei uns als Tester*in. Alles was du brauchst ist ein Spotify Account!',
    name: 'Name',
    email: 'E-Mail-Adresse',
    send: 'Abschicken',
    modal: {
      title: 'Hey, vielen Dank!',
      both:
        'Wir werden uns umgehend bei dir melden und dich als Tester*in hinzufügen. Alles weitere schreibe wir dir in einer E-Mail.',
      ios:
        'Wir werden uns umgehend bei dir melden und dich als Tester*in hinzufügen. Alles weitere schreibe wir dir in einer E-Mail.',
      android:
        'Wir werden uns umgehend bei dir melden und dich als Tester*in hinzufügen. Alles weitere schreibe wir dir in einer E-Mail.',
    },
  },
  /**
   * Footer
   */
  footer: {
    imprint: 'Impressum',
    privacy: 'Datenschutz',
  },
};

export default de;
